import React from "react";
import { jsPDF } from "jspdf";
import ButtonComponent from "./ButtonComponet";

import diseaseData from "../utils/diseases.json";

const MedicalReport = ({patientInfo}) => {


  const generateMedicalReport = () => {
    const doc = new jsPDF();

    const disease = diseaseData["diseases"][0];
    const reportTitle = "CheXcare Medical Report";
    const today = new Date();
    const date =
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    const reportContent = `Name: ${patientInfo.name}\nAge: ${patientInfo.age}\nGender: ${patientInfo.gender}\n`;

    doc.setFontSize(30).setFont("italic");
    doc.text(reportTitle, 10, 20);

    doc.setFontSize(14);
    doc.setFont("Noto Serif");
    doc.text("Date: " + date, 10, 35);

    doc.line(0, 45, 300, 45);

    doc.setFontSize(14);
    const textLines = doc
      .setFont("Noto Serif")
      .splitTextToSize(reportContent, 180);
    doc.text(textLines, 10, 50);

  
    const header = ["Pneumonia Score"];
    const data = [{ "Pneumonia Score": `${patientInfo.score}%` }];

    const config = {
      autoSize: false,
      printHeaders: true,
    };
    doc.table(170 / 2, 70, data, header, config);

    const diag = `Diagnosis: ${disease.diagnosis}\nTreatment: ${disease.treatment}`;

    doc.setFontSize(14);
    const reportText = doc.setFont("Noto Serif").splitTextToSize(diag, 180);
    doc.text(reportText, 10, 120);

    const pageHeight = doc.internal.pageSize.height;
    const footContent = `NB: CheXcare uses AI to help find pneumonia in X-rays. But it may not be perfect, so always see a doctor for diagnosis and treatment. CheXcare is for info only, not a replacement for a doctor. By using it, you agree to these terms. If you have health concerns, see a doctor.`;

    const footer = doc
      .setTextColor(255, 0, 0)
      .setFont("Noto Serif", "italic")
      .splitTextToSize(footContent, 180);

    doc.text(footer, 10, pageHeight - 30);

    doc.save("PneumoniaMedicalReport.pdf");
  };

  return (
    <div>
      <ButtonComponent onClick={generateMedicalReport} />
    </div>
  );
};

export default MedicalReport;
